import { Box, BoxProps } from '@hover/blueprint';
import { StaticImage } from 'gatsby-plugin-image';
import React from 'react';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import Slider from 'react-slick';

const settings = {
  dots: false,
  infinite: true,
  dragControls: false,
  draggable: false,
  swipeToSlide: false,
  speed: 2000,
  autoplaySpeed: 2000,
  slidesToShow: 6,
  autoplay: true,
  variableWidth: true,
  responsive: [
    {
      breakpoint: 834,
      settings: {
        slidesToShow: 1,
      },
    },
    {
      breakpoint: 1152,
      settings: {
        slidesToShow: 2,
      },
    },
    {
      breakpoint: 9999,
      settings: {
        slidesToShow: 4,
      },
    },
  ],
};

interface Props extends BoxProps {}

const Slide: React.FC<Props> = ({ children, ...restProps }) => (
  <Box height="50px" {...restProps} px="50px" w="auto">
    {children}
  </Box>
);

const LogoSlider: React.FC = () => (
  <Box overflow="visible" display="block" width="100%" height="50px" mb={1000}>
    <Slider {...settings}>
      <Slide>
        <StaticImage
          quality={100}
          placeholder="blurred"
          width={44}
          height={46}
          src="../../../assets/images/gaf_logo.png"
          alt="gaf logo"
        />
      </Slide>
      <Slide>
        <StaticImage
          quality={100}
          placeholder="blurred"
          width={73}
          height={37}
          src="../../../assets/images/srs_logo.png"
          alt="srs logo"
        />
      </Slide>
      <Slide>
        <StaticImage
          quality={100}
          placeholder="blurred"
          width={170}
          height={35}
          src="../../../assets/images/plygem_logo.png"
          alt="plygem logo"
        />
      </Slide>

      <Slide>
        <StaticImage
          quality={100}
          placeholder="blurred"
          width={162}
          height={38}
          src="../../../assets/images/travelers_vector_logo_red.png"
          alt="travelers logo"
        />
      </Slide>
      <Slide>
        <StaticImage
          quality={100}
          placeholder="blurred"
          width={37}
          height={37}
          src="../../../assets/images/owens_corning_logo.png"
          alt="owens corning logo"
        />
      </Slide>
      <Slide>
        <StaticImage
          quality={100}
          placeholder="blurred"
          width={190}
          height={40}
          src="../../../assets/images/bacon_roofing_supply_logo.png"
          alt="bacon roofing supply logo"
        />
      </Slide>
      <Slide>
        <StaticImage
          quality={100}
          placeholder="blurred"
          width={170}
          height={23}
          src="../../../assets/images/state_farm_logo_1.png"
          alt="state farm logo"
        />
      </Slide>
      <Slide>
        <StaticImage
          quality={100}
          placeholder="blurred"
          width={87}
          height={40}
          src="../../../assets/images/abc_logo.png"
          alt="abc logo"
        />
      </Slide>
      <Slide>
        <StaticImage
          quality={100}
          placeholder="blurred"
          width={162}
          height={33}
          src="../../../assets/images/james_hardie_logo.png"
          alt="james hardie logo"
        />
      </Slide>
    </Slider>
  </Box>
);

export default LogoSlider;
